import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import classes from './CoachStatus.module.scss'

const STATUS_LABEL_KEYS = {
  active: 'coaches.table.statuses.active',
  invited: 'coaches.table.statuses.pendingInvitation',
  inactive: 'coaches.table.statuses.inactive',
}

const CoachStatus = ({ status }) => {
  const { t } = useTranslation()

  return <span className={classes[status] || classes.active}>{t(STATUS_LABEL_KEYS[status] || STATUS_LABEL_KEYS.active)}</span>
}

CoachStatus.propTypes = {
  status: PropTypes.string,
}

export default CoachStatus
